/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React from 'react';
import orgc_wordmark_logo from '../../static/img/header/orgc-wordmark-logo.svg'
import orgc_wordmark_logo_cn from '../../static/img/header/orgc-wordmark-logo-cn.svg'
import ic_org_svg from '../../static/img/header/ic-organization.svg'
import HeaderOrgSelectorComponent from "./HeaderOrgSelectorComponent";
import HeaderUtilComponent from "./HeaderUtilComponent";
import { useAuthSession } from "../../context/AuthSessionContext";
import {useNavigate} from "../../hook/NavigateHook";
import {useRegion} from "../../context/RegionContext";
import HeaderUtilServiceComponent from "./HeaderUtilServiceComponent";
import {useOrganization} from "../../context/OrganizationContext";
import {useTranslation} from "react-i18next";


const ROLE_LABELS = {
    owner: '@Owner@',
    user_manager: '@User Manager@',
    member: '@Member@'
};

const MainHeaderComponent = ({refresh}) => {
    const {t} = useTranslation();
    const {session} = useAuthSession();
    // console.log(`header get token ${session}`, session)
    const {goHome} = useNavigate()
    const {getCurrentDomainRegion} = useRegion();
    const is_china = getCurrentDomainRegion() === 'CHINA';
    const {getCurrentOrg, userProfile} = useOrganization();
    const organization = getCurrentOrg();
    const {role} = userProfile();

    const is404 = () => {
        return window.location.pathname === '/404_page_not_found'
    }

    return (
        <header className="header m--header">
            <div className="utils" data-qnap-services>
                <HeaderUtilServiceComponent/>
            </div>

            <div className="app-name" data-location={is_china ? 'cn' : 'global'} onClick={goHome}>
                <div className="logo"></div>
                <div className="name">Organization Center</div>
                <div className="badge">.CN</div>
            </div>

            {(session === true || session.length > 0) && !is404() &&
                <div className="org-list">
                    <div className="divide"/>

                    <HeaderOrgSelectorComponent refresh={refresh}/>

                </div>
            }
            {organization && window.location.pathname.length > 1 && (session === true || session.length > 0) && !is404() &&
                <div className="user-role">
                    <div className="divide"></div>
                    <div className="role-label">
                        <span className="role-label__text">{t('@Role@')}</span>
                        <span className="role-label__value">{t(ROLE_LABELS[role] || '@Member@')}</span>
                    </div>
                </div>
            }
            {!is404() && <HeaderUtilComponent/>}

        </header>
    );
};

export default MainHeaderComponent;
